import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative rounded-xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20abstract%20warm%20geometric%20banner%20background%20with%20flowing%20golden%20amber%20curves%2C%20dark%20sophisticated%20texture%2C%20premium%20brand%20atmosphere%2C%20soft%20dramatic%20lighting%2C%20luxurious%20corporate%20style%2C%20clean%20minimalist%20composition&width=1280&height=500&seq=kaiyun-cta-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
          </div>

          <div className="relative z-10 py-12 md:py-16 px-6 md:px-12 text-center">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-white mb-3">
              准备好开始了吗？
            </h2>
            <p className="text-white/70 text-sm md:text-base max-w-lg mx-auto mb-8">
              立即加入开云平台，体验安全、稳定、专业的一站式数字服务，数百万用户的选择等待您的加入
            </p>
            <div className="flex items-center justify-center gap-3 flex-wrap">
              <Link
                to="/about#contact"
                className="px-6 py-3 rounded-md bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
              >
                立即注册
              </Link>
              <Link
                to="/category/all"
                className="px-6 py-3 rounded-md border border-white/30 text-white text-sm font-semibold hover:bg-white/10 transition-all duration-200 whitespace-nowrap"
              >
                探索服务
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}